export default {
  opponentRank: {
    rankSummary: "Ranking {{rank}} em {{marketName}}",
    feedSubtitle: "Ranking DEF de {{team}}",
  },
};
